export default __webpack_public_path__ + "static/media/electric-sale.1531b0ff.png";